import type { TagPath } from "@/types/dataPointTypes.ts"

export const getFullTagPath = (path: TagPath): string => {
  const pathArray: string[] = []
  if (path.historyProvider) {
    pathArray.push(path.historyProvider)
  }
  if (path.driver) {
    pathArray.push(path.driver)
  }
  if (path.tag) {
    const tagPath = path.tag.split("/")
    tagPath.forEach((f) => pathArray.push(f))
  }

  return pathArray.join("/")
}
